import React, { useMemo } from 'react';
import { toast } from 'sonner';
import { IconCopy, IconInfoCircle } from '@tabler/icons-react';
import { copyTextToClipboard, getBillingUsageEndpointUrl } from '../utils/billingEndpointUrl';

/** Info box with the Endpoint URL to paste into the Billing app. */
const BillingEndpointInfo: React.FC = () => {
    const endpointUrl = useMemo(() => getBillingUsageEndpointUrl(), []);

    const handleCopy = () => {
        copyTextToClipboard(endpointUrl)
            .then(() => toast.success('Endpoint URL copied to clipboard', { id: 'copy-billing-endpoint' }))
            .catch(() => toast.error('Failed to copy Endpoint URL', { id: 'copy-billing-endpoint' }));
    };

    return (
        <div className="alert alert-info mb-3" role="note">
            <div className="d-flex align-items-start gap-2">
                <IconInfoCircle size={20} className="flex-shrink-0 mt-1" />
                <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="fw-semibold mb-1">Endpoint URL for the Billing app</div>
                    <div className="small mb-2">
                        Paste this URL into the connection settings in the Billing app. Billing uses it,
                        together with the connection Code and Key, to pull usage from this PMS.
                    </div>
                    <div className="input-group input-group-sm">
                        <input
                            type="text"
                            className="form-control font-monospace"
                            value={endpointUrl}
                            readOnly
                            aria-label="Billing endpoint URL"
                            onFocus={(e) => e.currentTarget.select()}
                        />
                        <button type="button" className="btn btn-outline-secondary" onClick={handleCopy} title="Copy Endpoint URL">
                            <IconCopy size={16} className="me-1" /> Copy
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BillingEndpointInfo;
